// frontend/src/components/Footer.jsx
import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      {/* Organization schema */}
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Kiruna Tours",
            "url": "https://www.kirunatours.com/",
            "logo": "https://www.kirunatours.com/logo-512.png",
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+46706866709",
              "contactType": "Customer Support",
              "areaServed": "SE",
              "availableLanguage": ["English", "Swedish"]
            },
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Kiruna",
              "addressCountry": "SE"
            },
            "sameAs": [
              "https://www.facebook.com/aurorarivercamp",
              "https://www.instagram.com/aurorarivercamp",
              "https://www.tiktok.com/@aurorarivercamp"
            ]
          })}
        </script>
      </Helmet>

      <div className="footer-columns">
        {/* Company / contact */}
        <div className="footer-col contact-info">
          <p>&copy; {year} Aurora RiverCamp AB</p>
          <p>
            📍 Kiruna, Sweden<br />
            📞 +46 (0) 706 86 67 09<br />
            ✉️ reception(at)kirunatours.com
          </p>
        </div>

        {/* Site links (trailing slash på interna sidor) */}
        <div className="footer-col site-links">
          <div className="footer-heading">Site</div>
          <ul>
            <li><Link to="/tours/">Tours</Link></li>
            <li><Link to="/travel-guide/">Travel Guide</Link></li>
            <li><Link to="/about/">About</Link></li>
            <li><Link to="/contact/">Contact</Link></li>
            <li><Link to="/travel-guide/comparisons/">Compare Arctic Destinations</Link></li>
            <li><Link to="/privacy/">Privacy Policy</Link></li>
            {/* Endast XML-sitemap (ingen /site-map.html) */}
            <li><a href="/sitemap.xml">XML sitemap</a></li>
          </ul>
        </div>

        {/* Extra internlänkar → hjälper internt länkflöde */}
        <div className="footer-col explore-links">
          <div className="footer-heading">Explore Tours</div>
          <ul>
            <li><Link to="/tours/northern-lights/">Northern Lights</Link></li>
            <li><Link to="/tours/dog-sledding/">Dog Sledding</Link></li>
            <li><Link to="/tours/snowmobile/">Snowmobile</Link></li>
            <li><Link to="/tours/reindeer/">Reindeer</Link></li>
            <li><Link to="/tours/snowshoe/">Snowshoe</Link></li>
            <li><Link to="/tours/arctic-dining/">Arctic Dining</Link></li>
            <li><Link to="/tours/abisko/">Abisko</Link></li>
            <li><Link to="/tours/">All Tours</Link></li>
          </ul>
        </div>

        {/* Social */}
        <div className="footer-col social-links">
          <div className="footer-heading">Social</div>
          <ul>
            <li><a href="https://www.facebook.com/aurorarivercamp" target="_blank" rel="noopener noreferrer">Facebook</a></li>
            <li><a href="https://www.instagram.com/aurorarivercamp" target="_blank" rel="noopener noreferrer">Instagram</a></li>
            <li><a href="https://www.tiktok.com/@aurorarivercamp" target="_blank" rel="noopener noreferrer">TikTok</a></li>
          </ul>
        </div>
      
        {/* Helt korrekta och uppdaterade länkar baserat på er redirect-mappning */}
        <div className="footer-col seo-internal-links">
          <div className="footer-heading">Popular Guides</div>
          <ul>
            <li><Link to="/travel-guide/kiruna-winter-itinerary/">Top Things to Do in Kiruna</Link></li>
            <li><Link to="/travel-guide/swedish-lapland-winter-travel-guide/">Kiruna Travel Guide</Link></li>
            <li><Link to="/travel-guide/snowmobile-tours-in-kiruna-guide/">Snowmobile Tours in Kiruna</Link></li>
            <li><Link to="/travel-guide/kiruna-sami-reindeer-experiences/">Reindeer Experience in Kiruna</Link></li>
            <li><Link to="/travel-guide/kiruna-aurora-river-camp-unique-stays/">Glass Igloo Stay in Kiruna</Link></li>
            <li><Link to="/tours/day-trip-to-abisko/">Day Trip to Abisko</Link></li>
            <li><Link to="/tours/visit-the-world-famous-icehotel/">Visit the ICEHOTEL</Link></li>
            <li><Link to="/tours/ice-climbing-tour-in-abisko-beginner-friendly/">Ice Climbing in Abisko</Link></li>
          </ul>
        </div>

      </div>
    </footer>
  );
}